import { CloseSquare } from "iconsax-react";
import { useEffect, useState } from "react";
import { getToken } from "../../../../../utils/token";
import { Oval } from "react-loader-spinner";
import instance from "../../../../../axios/instance";
import { useLoaderData } from "react-router-dom";
import { toast } from "react-toastify";
import { LockKeyhole } from "lucide-react";

export default function NoteComponent({ isOpen, onClose, selectedNote, newNote, patientId, onNoteSaved }) {

  // selected note shpuld be note ID
  const [loadingNote, setLoadingNote] = useState(false)
  const [note, setNote] = useState("")
  const [title, setTitle] = useState("")
  const [noteDoctor, setNoteDoctor] = useState("")

  const { doctor } = useLoaderData()

  function handleTitle(event) {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
    setTitle(event.target.value);
  }

  function handleNotes(event) {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
    setNote(event.target.value);
  }

  // get latest note data
  async function getCurrentNote() {
    setLoading(true)
    instance
      .get(
        `/telemedicine/doctor/note/${selectedNote.id}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((response) => {
        setNote(response.data.note)
        setTitle(response.data.note_title)
        setNoteDoctor(response.data.doctor_id)
        setLoading(false)
      })
      .catch((error) => {
        console.log(error);
        setLoading(false)
      });
  }

  async function updateNote() {
    instance
      .post(
        "/telemedicine/doctor/note/update",
        {
          note_id: selectedNote.id,
          note_title: title,
          note: note,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        // getNotes();
        // getCurrentNote()
        // setNotesLoading(false);
        //toast.success("note updated")
        onNoteSaved(true)
      })
      .catch((error) => {
        toast.error("oops", {
          position: "bottom-right",
        });

        console.log(error);


        //setNotesLoading(false);
      });
  }

  async function addNote() {
    instance
      .post(
        "/telemedicine/doctor/note",
        {
          patient_id: patientId,
          note_title: title,
          note: note,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log("notes are", response.data);
        //getNotes();
        //setNotesLoading(false);
        // setIsNewNoteSaved({
        //   saved: true,
        //   noteId: response.data.noteId
        // })
        onNoteSaved(true)
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "bottom-right",
        });

        //setNotesLoading(false);
      });
  }

  useEffect(() => {
    if (!newNote) {
      getCurrentNote()
    }

  }, [selectedNote.id])

  const token = getToken();

  const [doc, setDoc] = useState(null);

  const [loading, setLoading] = useState(true);

  async function getDoctor() {
    const res = await instance.get("/doctor", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setDoc(res.data);

    setLoading(false);
  }

  useEffect(() => {
    getDoctor();
  }, [selectedNote]);

  return (
    <div
      className={`${isOpen ? "block" : "hidden"
        } bg-[#11111121] flex justify-center items-center fixed z-[1000] top-0 left-0 bottom-0 right-0`}
    >
      {loading || loadingNote ? (
        <div className="w-[750px] text-[14px] bg-white rounded-[8px]">
          <div className="p-3 border-b flex justify-between items-center">
            <div class="font-medium text-[14px]">Note</div>
            <button onClick={onClose}>
              <CloseSquare variant="Bold" size={20} />
            </button>
          </div>
          <div className="flex flex-col justify-center items-center px-3 py-10 gap-2 text-gray-500">
            <Oval
              width={24}
              height={24}
              color="#00b0ad"
              secondaryColor="#00b0ad22"
            />
            loading note...
          </div>
        </div>
      ) : (
        <div className="w-[750px] flex flex-col h-[70%] bg-white rounded-[8px]">
          <div className="p-3 border-b flex justify-between items-center">
            <div class="font-medium text-[14px]">Note</div>
            <button onClick={onClose}>
              <CloseSquare variant="Bold" size={20} />
            </button>
          </div>

          <div className="flex-1 flex flex-col">
            <div className="p-3 flex flex-col">

              {
                !newNote &&
                <div className="flex justify-between items-center text-[12px] py-2 font-medium text-gray-500">
                  <div>
                    Created on {new Date(selectedNote.created_at).toDateString()}
                  </div>

                  <div className="flex gap-1 items-center">
                    <LockKeyhole size={12} color="gray" />
                    {doc?.id === selectedNote.doctor_id
                      ? "You"
                      : selectedNote.doctor_name}{" "}
                    signed this note on{" "}
                    {new Date(selectedNote.created_at).toDateString()}
                  </div>
                </div>
              }

              {
                doctor.id !== noteDoctor && !newNote && <div className="bg-[#dd4b3922] rounded-[4px] mb-2 text-[#dd4b39] px-3 py-2 text-[14px] font-normal">You can't edit this note</div>
              }


              <textarea
                value={title}
                onChange={handleTitle}
                disabled={doctor.id !== noteDoctor && !newNote}
                placeholder="Title"
                aria-multiline
                className="resize-none bg-inherit text-[16px] outline-none font-semibold w-full"
              />

              <div className="overflow-y-scroll flex h-[330px]">
                <textarea
                  value={note}
                  onChange={handleNotes}
                  disabled={doctor.id !== noteDoctor && !newNote}
                  placeholder="Take a note..."
                  aria-multiline
                  className="resize-none flex-1 overflow-y-scroll bg-inherit text-[15px] outline-none font-normal w-full"
                />
              </div>
            </div>
          </div>

          <div className="p-3 border-t flex gap-3 justify-end items-center">
            <button
              onClick={onClose}
              className="px-3 py-2 text-gray-600 border-gray-600 border rounded-[4px] font-medium text-[14px]"
            >
              Close
            </button>

            {
              newNote ?
                <button
                  onClick={addNote}
                  className={`bg-[#00b0ad] border-[#00b0ad] text-white border rounded-[4px] px-3 py-2 font-medium text-[14px]`}
                >
                  Save and sign
                </button> :
                <button
                  onClick={updateNote}
                  disabled={doctor.id !== noteDoctor}
                  className={`${doctor.id === noteDoctor
                    ? "bg-[#00b0ad] border-[#00b0ad] text-white"
                    : "bg-[#00b0ad22] border-[#00b0ad22] text-[#00b0ad] cursor-not-allowed"
                    } border rounded-[4px] px-3 py-2 font-medium text-[14px]`}
                >
                  Update and sign
                </button>
            }

            {/* <button
              disabled={doctor.id !== noteDoctor}
              className={`${doctor.id === noteDoctor
                  ? "bg-[#00b0ad] border-[#00b0ad] text-white"
                  : "bg-[#00b0ad22] border-[#00b0ad22] text-[#00b0ad] cursor-not-allowed"
                } border rounded-[4px] px-3 py-2 font-medium text-[14px]`}
            >
              Update and sign
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
}
